module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (this.config.loading.content),
      expression: "this.config.loading.content"
    }],
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-end"
    },
    slot: "form-end"
  }, [_c('ed-button', {
    attrs: {
      "type": "warning",
      "value": "Gerar Documento",
      "icon": "fa fa-file-word-o",
      "title": "Clique aqui para gerar o LTCAT no formato .DOC"
    },
    on: {
      "click": _vm.gerarDocumento
    }
  }), _vm._v(" "), (_vm.formData.id > 0) ? _c('div', {
    staticClass: "col-12 text-left mt-3"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-ghe"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" Setores\n\t\t\t\t\t\t")]), _vm._v(" "), _c('LtcatGhe', {
    attrs: {
      "ltcat": _vm.formData
    }
  })], 1), _vm._v(" "), (this.validarPermissao(576)) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-docs"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  }), _vm._v(" Documentos e Anexos\n\t\t\t\t\t\t")]), _vm._v(" "), _c('LtcatAnexo', {
    attrs: {
      "ltcat": _vm.formData
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.validarPermissao(577)) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-orcamento"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" Orçamentos\n\t\t\t\t\t\t")]), _vm._v(" "), _c('LtcatOrcamento', {
    attrs: {
      "ltcat": _vm.formData
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c07afab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/editar.vue
// module id = 1522
// module chunks = 45